import type { OrderModel } from 'src/types/order';

import { useState } from 'react';

import { updateOrder } from 'src/api/order.api';

export function useUpdateExternalOrder() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const updateExternalOrder = async (id: number, orderData: OrderModel) => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await updateOrder(id, orderData);
      return result;
    } catch (err) {
      const updateError = err instanceof Error ? err : new Error('Error al actualizar el pedido');
      setError(updateError);
      throw updateError;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    updateExternalOrder,
    isLoading,
    error,
  };
}
